import { Navigate, Outlet, useSearchParams } from 'react-router';
import { useAppSelector } from '@/app/hooks';
import { selectIsAuthenticated } from '@/shared/session';
import { getSafeReturnTo, RETURN_TO_PARAM } from '../model/returnTo';

/**
 * Layout route guard for sign-in/registration. Once a session exists (including right after a
 * successful sign-in), it redirects to the page the user originally asked for.
 */
export function GuestOnly() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    return <Navigate to={getSafeReturnTo(searchParams.get(RETURN_TO_PARAM))} replace />;
  }

  return <Outlet />;
}
